<template>
	<div>
		<div v-if="!isLoading" class="pb-30" id="monthly_report_pdf">
			<div class="__goal-management-student-detail p-10 md-down:px-4">
				<div class="__goal-management-student-detail__header pt-5">
					<div
						class="
							flex
							justify-between
							items-center
							w-full
							md-down:flex-col md-down:items-start
						"
					>
						<router-link
							:to="`/record/student/${report?.student?.id}`"
						>
							<div class="flex items-center">
								<img
									v-if="report?.student?.profile_photo?.w200"
									:src="report?.student?.profile_photo?.w200"
									alt=""
									class="
										shadow-sm
										inline-block
										h-14
										w-14
										rounded-full
									"
									style="min-width: 56px"
								/>
								<span
									v-else
									:style="{
										background:
											report?.student?.profile_photo
												?.default?.color,
									}"
									class="
										inline-flex
										items-center
										justify-center
										h-14
										w-14
										rounded-full
									"
									style="min-width: 56px"
								>
									<span
										class="
											font-medium
											leading-none
											text-white text-4xl
										"
										>{{
											report?.student?.profile_photo
												?.default?.initial
										}}</span
									>
								</span>
								<div class="ml-4">
									<div
										class="
											font-bold
											text-neutral-700 text-4xl
											md-down:text-2xl
										"
									>
										{{ report?.student?.name }}
									</div>
									<div
										v-if="is_old_data && dateData"
										class="
											text-green-500
											font-semibold
											text-xs
											uppercase
											letter-spacing-8
										"
									>
										{{ dateData }}
									</div>
									<div
										v-else-if="report?.student?.age"
										class="
											text-green-500
											font-semibold
											text-xs
											uppercase
										"
									>
										{{ report?.student?.age }}
										{{
											report?.student?.learning_time
												? `| ${report?.student?.learning_time}`
												: ''
										}}
									</div>
								</div>
							</div>
						</router-link>
					</div>
				</div>
				<div>
					<div class="mt-10">
						<div
							class="
								bg-white
								shadow-sm
								rounded-2xl
								overflow-hidden
								pb-4
							"
						>
							<div
								class="
									bg-orange-50
									p-4
									px-6
									flex
									md:items-center
									justify-between
									text-gray-700
									md-down:flex-col
								"
							>
								<div class="font-semibold text-lg">
									Báo cáo
									<span class="text-green-500"
										>Kế Hoạch
										{{
											report?.report_for_plan?.order
										}}</span
									>
								</div>
								<div
									v-if="report?.read_by_parent"
									class="flex items-center md-down:mt-1"
								>
									<span v-if="report?.read_by_parent_role">{{
										report?.read_by_parent_role
									}}</span
									><span v-else>Phụ huynh</span>
									<span class="ml-1.5"> xác nhận đã xem</span>
									<div class="ml-2">
										<svg
											fill="none"
											height="20"
											viewBox="0 0 20 20"
											width="20"
											xmlns="http://www.w3.org/2000/svg"
										>
											<mask
												id="path-1-inside-1_6533_14812"
												fill="white"
											>
												<path
													d="M9.26842 5.21202H2.62983C1.64107 5.21202 0.833984 6.01907 0.833984 7.00787V14.7764C0.833984 15.7652 1.64104 16.5723 2.62983 16.5723H5.05117L5.05131 19.2962C5.05131 19.9016 5.75761 20.2245 6.20153 19.8208L10.0354 16.552H13.3244C14.3132 16.552 15.1203 15.745 15.1203 14.7562L15.1201 11.0838C11.8917 11.0838 9.2685 8.44048 9.2685 5.21195L9.26842 5.21202Z"
												/>
												<path
													d="M15.1402 0.833374C12.7189 0.833374 10.7616 2.79065 10.7616 5.21202C10.7616 7.63339 12.7189 9.59066 15.1402 9.59066C17.5616 9.59066 19.5189 7.63339 19.5189 5.21202C19.5189 2.79065 17.5616 0.833374 15.1402 0.833374ZM17.2791 4.60668L15.0999 6.78591C14.9788 6.90696 14.7972 6.98775 14.6155 6.98775C14.434 6.98775 14.2524 6.9071 14.1312 6.78591L12.981 5.63569C12.7187 5.37333 12.7187 4.92938 12.981 4.66717C13.2434 4.40482 13.6873 4.40482 13.9495 4.66717L14.5953 5.31294L16.2902 3.61802C16.5526 3.35566 16.9965 3.35566 17.2587 3.61802C17.5616 3.90051 17.5616 4.34443 17.2791 4.60668H17.2791Z"
												/>
											</mask>
											<path
												d="M9.26842 5.21202H2.62983C1.64107 5.21202 0.833984 6.01907 0.833984 7.00787V14.7764C0.833984 15.7652 1.64104 16.5723 2.62983 16.5723H5.05117L5.05131 19.2962C5.05131 19.9016 5.75761 20.2245 6.20153 19.8208L10.0354 16.552H13.3244C14.3132 16.552 15.1203 15.745 15.1203 14.7562L15.1201 11.0838C11.8917 11.0838 9.2685 8.44048 9.2685 5.21195L9.26842 5.21202Z"
												fill="#339588"
											/>
											<path
												d="M15.1402 0.833374C12.7189 0.833374 10.7616 2.79065 10.7616 5.21202C10.7616 7.63339 12.7189 9.59066 15.1402 9.59066C17.5616 9.59066 19.5189 7.63339 19.5189 5.21202C19.5189 2.79065 17.5616 0.833374 15.1402 0.833374ZM17.2791 4.60668L15.0999 6.78591C14.9788 6.90696 14.7972 6.98775 14.6155 6.98775C14.434 6.98775 14.2524 6.9071 14.1312 6.78591L12.981 5.63569C12.7187 5.37333 12.7187 4.92938 12.981 4.66717C13.2434 4.40482 13.6873 4.40482 13.9495 4.66717L14.5953 5.31294L16.2902 3.61802C16.5526 3.35566 16.9965 3.35566 17.2587 3.61802C17.5616 3.90051 17.5616 4.34443 17.2791 4.60668H17.2791Z"
												fill="#339588"
											/>
											<path
												d="M9.26842 5.21202V6.21202H9.68041L9.97284 5.92181L9.26842 5.21202ZM5.05117 16.5723L6.05117 16.5722L6.05112 15.5723H5.05117V16.5723ZM5.05131 19.2962H6.05131V19.2962L5.05131 19.2962ZM6.20153 19.8208L5.55273 19.0599L5.54057 19.0702L5.52876 19.081L6.20153 19.8208ZM10.0354 16.552V15.552H9.66693L9.38656 15.7911L10.0354 16.552ZM15.1203 14.7562H16.1203V14.7561L15.1203 14.7562ZM15.1201 11.0838L16.1201 11.0837L16.1201 10.0838H15.1201V11.0838ZM9.2685 5.21195H10.2685V2.81066L8.56408 4.50216L9.2685 5.21195ZM17.2791 4.60668V3.60668H16.8649L16.572 3.89957L17.2791 4.60668ZM15.0999 6.78591L14.3927 6.0788V6.0788L15.0999 6.78591ZM14.1312 6.78591L14.8384 6.07883L14.8383 6.0788L14.1312 6.78591ZM12.981 4.66717L13.6879 5.37449L13.6881 5.37428L12.981 4.66717ZM13.9495 4.66717L13.2422 5.37408L13.2424 5.37428L13.9495 4.66717ZM14.5953 5.31294L13.8882 6.02005L14.5953 6.72716L15.3024 6.02005L14.5953 5.31294ZM17.2587 3.61802L16.5514 4.32492L16.5638 4.33735L16.5767 4.34934L17.2587 3.61802ZM17.2791 4.60668V5.60668H17.6718L17.9595 5.33955L17.2791 4.60668ZM9.26842 4.21202H2.62983V6.21202H9.26842V4.21202ZM2.62983 4.21202C1.0888 4.21202 -0.166016 5.46677 -0.166016 7.00787H1.83398C1.83398 6.57137 2.19334 6.21202 2.62983 6.21202V4.21202ZM-0.166016 7.00787V14.7764H1.83398V7.00787H-0.166016ZM-0.166016 14.7764C-0.166016 16.3175 1.08874 17.5723 2.62983 17.5723V15.5723C2.19333 15.5723 1.83398 15.2129 1.83398 14.7764H-0.166016ZM2.62983 17.5723H5.05117V15.5723H2.62983V17.5723ZM4.05117 16.5723L4.05131 19.2963L6.05131 19.2962L6.05117 16.5722L4.05117 16.5723ZM4.05131 19.2962C4.05131 20.7308 5.75932 21.5746 6.8743 20.5607L5.52876 19.081C5.56957 19.0439 5.63148 19.0125 5.70324 19.003C5.7699 18.9941 5.82886 19.0061 5.87522 19.0272C5.97096 19.0709 6.05131 19.1771 6.05131 19.2962H4.05131ZM6.85034 20.5818L10.6842 17.313L9.38656 15.7911L5.55273 19.0599L6.85034 20.5818ZM10.0354 17.552H13.3244V15.552H10.0354V17.552ZM13.3244 17.552C14.8655 17.552 16.1203 16.2973 16.1203 14.7562H14.1203C14.1203 15.1927 13.7609 15.552 13.3244 15.552V17.552ZM16.1203 14.7561L16.1201 11.0837L14.1201 11.0838L14.1203 14.7562L16.1203 14.7561ZM15.1201 10.0838C12.4485 10.0838 10.2685 7.89266 10.2685 5.21195H8.2685C8.2685 8.98829 11.335 12.0838 15.1201 12.0838V10.0838ZM8.56408 4.50216L8.56401 4.50223L9.97284 5.92181L9.97291 5.92174L8.56408 4.50216ZM15.1402 -0.166626C12.1666 -0.166626 9.7616 2.23836 9.7616 5.21202H11.7616C11.7616 3.34294 13.2712 1.83337 15.1402 1.83337V-0.166626ZM9.7616 5.21202C9.7616 8.18567 12.1666 10.5907 15.1402 10.5907V8.59066C13.2712 8.59066 11.7616 7.0811 11.7616 5.21202H9.7616ZM15.1402 10.5907C18.1139 10.5907 20.5189 8.18567 20.5189 5.21202H18.5189C18.5189 7.0811 17.0093 8.59066 15.1402 8.59066V10.5907ZM20.5189 5.21202C20.5189 2.23836 18.1139 -0.166626 15.1402 -0.166626V1.83337C17.0093 1.83337 18.5189 3.34293 18.5189 5.21202H20.5189ZM16.572 3.89957L14.3927 6.0788L15.807 7.49302L17.9862 5.31378L16.572 3.89957ZM14.3927 6.0788C14.428 6.04356 14.4614 6.02372 14.4897 6.01171C14.5185 5.9995 14.5601 5.98775 14.6155 5.98775V7.98775C15.0749 7.98775 15.5074 7.79262 15.807 7.49302L14.3927 6.0788ZM14.6155 5.98775C14.6709 5.98775 14.7125 5.99947 14.7413 6.01169C14.7696 6.02372 14.8031 6.0436 14.8384 6.07883L13.4241 7.49298C13.724 7.79296 14.1566 7.98775 14.6155 7.98775V5.98775ZM14.8383 6.0788L13.6881 4.92858L12.2739 6.34279L13.4241 7.49302L14.8383 6.0788ZM13.6881 4.92858C13.7593 4.99977 13.7842 5.08446 13.7842 5.15137C13.7842 5.21829 13.7593 5.30314 13.6879 5.37449L12.2741 3.95986C11.6208 4.61275 11.6211 5.69002 12.2739 6.34279L13.6881 4.92858ZM13.6881 5.37428C13.6169 5.44547 13.5322 5.47041 13.4653 5.47041C13.3984 5.47041 13.3136 5.44546 13.2422 5.37408L14.6568 3.96027C14.0039 3.307 12.9267 3.3073 12.2739 3.96007L13.6881 5.37428ZM13.2424 5.37428L13.8882 6.02005L15.3024 4.60584L14.6566 3.96007L13.2424 5.37428ZM15.3024 6.02005L16.9973 4.32513L15.5831 2.91091L13.8882 4.60584L15.3024 6.02005ZM16.9973 4.32513C16.9261 4.39632 16.8414 4.42125 16.7745 4.42125C16.7076 4.42125 16.6228 4.39631 16.5514 4.32492L17.966 2.91112C17.3131 2.25785 16.2359 2.25814 15.5831 2.91091L16.9973 4.32513ZM16.5767 4.34934C16.5321 4.3078 16.4899 4.23178 16.4886 4.13418C16.4872 4.03723 16.5275 3.93999 16.5988 3.8738L17.9595 5.33955C18.6894 4.66193 18.6461 3.5445 17.9408 2.88671L16.5767 4.34934ZM17.2791 3.60668H17.2791V5.60668H17.2791V3.60668Z"
												fill="#339588"
												mask="url(#path-1-inside-1_6533_14812)"
											/>
										</svg>
									</div>
								</div>
							</div>
							<div
								class="
									flex
									items-start
									justify-between
									flex-nowrap
									md-down:flex-col md-down:items-start
									px-6
									mt-4
								"
							>
								<div>
									<div v-if="report?.apply_date">
										Ngày áp dụng KH:
										{{
											$filters.formatDate2(
												report?.apply_date
											)
										}}
									</div>
								</div>
							</div>
							<div
								class="
									flex
									items-start
									justify-between
									flex-nowrap
									md-down:flex-col md-down:items-start
									px-6
									mt-2.5
								"
							>
								<div>
									<div v-if="report?.done_date">
										Ngày kết thúc KH:
										{{
											$filters.formatDate2(
												report?.done_date
											)
										}}
										<span
											v-if="report?.is_pending_done_date"
											>(dự kiến)</span
										>
									</div>
								</div>
								<router-link
									:to="`/record/employee/${report?.submitted_by_staff?.id}`"
								>
									<div v-if="report?.submitted_by_staff">
										Trị liệu viên báo cáo
										<span
											class="font-semibold text-blue-700"
											>{{
												report?.submitted_by_staff?.name
											}}</span
										>
									</div>
								</router-link>
							</div>
							<div
								class="
									flex
									items-start
									justify-between
									flex-nowrap
									md-down:flex-col md-down:items-start
									px-6
									mt-2.5
								"
							>
								<div>
									<div v-if="report?.completed_at">
										Ngày hoàn thành BC:
										{{
											$filters.formatDate2(
												report?.completed_at
											)
										}}
									</div>
								</div>
								<div
									v-if="report && report.sent_at"
									class="flex items-center gap-2"
								>
									<router-link
										:to="`/record/employee/${report?.sent_by_staff?.id}`"
									>
										<div v-if="report?.sent_by_staff">
											<span
												class="
													font-semibold
													text-blue-700
												"
												>{{
													report?.sent_by_staff?.name
												}}</span
											>
										</div>
									</router-link>
									<span
										>đã gửi KH tới PH
										{{
											$filters.formatDateTime(
												report.sent_at
											)
										}}</span
									>
								</div>
							</div>
						</div>
					</div>
					<div v-if="report?.note" class="mt-10">
						<div class="bg-white shadow-sm rounded-2xl">
							<div class="font-semibold text-neutral-600 p-6">
								Nhận xét chung của tháng
							</div>
							<div
								class="
									p-6
									border-t border-orange-100
									whitespace-pre-line
								"
								v-html="report?.note"
							></div>
						</div>
					</div>
					<div
						class="
							bg-white
							shadow-sm
							rounded-2xl
							overflow-hidden
							mt-10
						"
					>
						<div class="font-semibold text-neutral-500 p-6">
							Chuyên cần
						</div>
						<div
							class="
								border-t border-orange-50
								p-6
								flex
								items-center
								justify-center
								flex-col
							"
						>
							<div
								class="text-neutral-600 font-semibold mb-5"
								style="font-size: 72px"
							>
								{{ report?.lesson_count }}
							</div>
							<div class="text-neutral-500 mb-5 text-center">
								Số buổi học tháng này
							</div>
							<div
								v-if="
									attendance.attendance_percent >= 0 && false
								"
								class="text-neutral-500 mb-5"
							>
								Tỷ lệ chuyên cần của trẻ tháng này so với tháng
								trước
							</div>
							<div v-if="false" class="flex items-center">
								<div
									v-if="attendance.attendance_percent > 0"
									class="
										text-neutral-600 text-4xl
										font-semibold
										mr-3
									"
								>
									{{
										Math.abs(
											Math.round(
												+attendance.attendance_percent *
													10
											) / 10
										) + '%'
									}}
								</div>
								<div
									v-show="
										+attendance?.attendance_compare_with_last_percent !==
										0
									"
									:class="
										+attendance?.attendance_compare_with_last_percent >=
										0
											? 'bg-green-50 text-green-400'
											: 'bg-sienna-50 text-sienna-400'
									"
									class="
										grow-value
										flex flex-nowrap
										rounded-lg
										py-1
										px-2
										items-center
										w-fit
									"
								>
									<svg
										:class="{
											'transform rotate-180':
												+attendance?.attendance_compare_with_last_percent >=
												0,
										}"
										fill="none"
										height="12"
										viewBox="0 0 10 12"
										width="10"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											clip-rule="evenodd"
											d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
											fill="currentColor"
											fill-rule="evenodd"
										/>
									</svg>
									<div
										class="
											ml-2
											font-bold
											text-sm text-neutral-700
										"
									>
										{{
											Math.abs(
												Math.round(
													+attendance?.attendance_compare_with_last_percent *
														10
												) / 10
											)
										}}%
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-if="
							radarData.length && radarData[0]?.data.length >= 3
						"
						class="mt-10"
					>
						<div
							class="
								bg-white
								shadow-sm
								overflow-hidden
								rounded-2xl
								mb-10
								pb-5
							"
						>
							<div class="font-semibold text-neutral-500 p-6">
								Biểu đồ mối tương quan giữa kết quả các lĩnh vực
								trong tháng
							</div>
							<div
								class="
									p-6
									border-t border-orange-50
									md-down:px-0
									overflow-x-auto
									w-full
								"
							>
								<apexchart
									:options="radarChartOptions"
									:series="radarData"
									height="700"
									type="radar"
								>
								</apexchart>
								<div
									class="
										py-4
										flex flex-wrap
										gap-6
										justify-center
										items-center
									"
								>
									<div
										v-for="(c, index) in categories"
										:key="c"
										class="
											flex
											items-center
											flex-nowrap
											gap-2
										"
									>
										<div
											class="
												font-bold
												text-lf text-neutral-700
											"
										>
											{{ index + 1 }}: {{ c }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div
							class="
								bg-white
								shadow-sm
								rounded-2xl
								overflow-hidden
								mb-10
								pb-5
							"
						>
							<div class="font-semibold text-neutral-500 p-6">
								Mối tương quan giữa kết quả, cảm xúc và sự tham
								gia của trẻ trong tháng
							</div>
							<div
								class="
									p-6
									border-t border-orange-50
									md-down:px-0
									overflow-x-auto
									w-full
								"
							>
								<apexchart
									ref="mixChart"
									:options="mixChartOptions"
									:series="
										emotion_cooperation_result_by_day_data
									"
									height="600"
									style="min-width: 1000px; width: 100%"
									width="100%"
								></apexchart>
							</div>
						</div>
					</div>
					<div class="relative mt-12">
						<div
							aria-hidden="true"
							class="absolute inset-0 flex items-center"
						>
							<div class="w-full border-t border-neutral-300" />
						</div>
						<div class="relative flex items-center justify-center">
							<div
								class="
									px-2.5
									py-1
									bg-body
									text-neutral-600
									font-semibold
								"
							>
								Kết quả can thiệp tại thời điểm báo cáo
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div class="p-6 bg-white shadow-sm rounded-2xl">
							<div class="font-semibold text-neutral-600 mb-6">
								Thống kê của tháng
								{{ $filters.toMMYYY(report?.month_start) }}
							</div>
							<div
								class="flex flex-nowrap w-full md-down:flex-col"
							>
								<div
									v-if="false"
									class="
										p-6
										border
										rounded-l-lg
										border-neutral-200
										w-full
										md-down:rounded-t md-down:rounded-b-none
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2 mb-1"
											height="32"
											src="@/assets/images/icons/schedule.png"
											style="height: 32px"
											width="32"
										/>
										{{ report?.lesson_count }}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Tống số buổi học
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border
										rounded-l-lg
										border-neutral-200
										w-full
										md-down:rounded-t md-down:rounded-b-none
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/abc.png"
											style="height: 32px"
											width="32"
										/>
										{{
											Number(report?.skill_count || 0) +
											'/' +
											Number(
												stats?.total_skill_count || 0
											)
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Lĩnh vực đã học
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border-t border-b border-neutral-200
										w-full
										md-down:border-l
										md-down:border-r
										md-down:border-b-0
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											Number(report?.goal_count || 0) +
											'/' +
											Number(stats?.total_goal_count || 0)
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu đã học
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border-l
										border-t
										border-b
										border-neutral-200
										w-full
										md-down:border-r md-down:border-b-0
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											assessment_report_next_plan
												?.completed?.count
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu đã hoàn thành
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border-l
										border-t
										border-b
										border-neutral-200
										w-full
										md-down:border-r md-down:border-b-0
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											assessment_report_next_plan
												?.continued?.count
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu sẽ tiếp tục
										</span>
									</div>
								</div>
								<div
									class="
										p-6
										border
										rounded-r-lg
										border-neutral-200
										w-full
										md-down:rounded-b md-down:rounded-t-none
									"
								>
									<div
										class="
											text-33
											font-bold
											text-neutral-600
											mb-6
											flex flex-nowrap
											items-center
										"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{
											assessment_report_next_plan?.stopped
												?.count
										}}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Mục tiêu sẽ tạm dừng</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div class="grid grid-cols-2 gap-8 xl-down:grid-cols-1">
							<div
								class="
									bg-white
									shadow-sm
									rounded-2xl
									overflow-hidden
								"
							>
								<div class="font-semibold text-neutral-500 p-6">
									Cảm xúc của trẻ trong tháng
								</div>
								<div
									class="
										border-t border-orange-50
										flex
										justify-center
										items-center
										p-6
										md-down:flex-col
									"
								>
									<div
										class="
											relative
											w-1/2
											md-down:w-full
											flex
											items-center
											justify-center
										"
									>
										<apexchart
											:options="chartOptions3"
											:series="series3"
											height="220"
											type="donut"
										>
										</apexchart>
										<div
											class="
												text-center
												absolute
												top-1/2
												left-1/2
												transform
											"
											style="
												transform: translate(
													-50%,
													-50%
												);
											"
										>
											<div class="text-neutral-500">
												Cảm xúc
											</div>
										</div>
									</div>
									<div
										class="
											w-1/3
											md-down:w-full md-down:mt-4
										"
									>
										<div
											v-if="series3[0] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/happy.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #9edf93"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Vui vẻ
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[0] }}
												%
											</div>
										</div>
										<div
											v-if="series3[1] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/5565d66a50b44df9ae37a955bdfb3757.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #d0db54"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Bình thường
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[1] }}
												%
											</div>
										</div>
										<div
											v-if="series3[2] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/cf1f643bc1244f5e8e37767bc946d607.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #ffe68c"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Khó chịu
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[2] }}
												%
											</div>
										</div>
										<div
											v-if="series3[3] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/5ede936757cd4fbdb6247bad22bf454d.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #ff9d6d"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Tức giận
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[3] }}
												%
											</div>
										</div>
										<div
											v-if="series3[4] > 0"
											class="
												flex flex-nowrap
												items-center
												justify-between
												w-full
												mt-2.5
											"
										>
											<div
												class="
													flex flex-nowrap
													items-center
												"
											>
												<img
													alt=""
													height="24"
													src="@/assets/images/emoji/0b356bb507d64b9489e2fbced131f795.png"
													width="24"
												/>
												<div
													class="
														h-2.5
														w-2.5
														rounded-full
														ml-2
													"
													style="background: #ff6967"
												></div>
												<div
													class="
														ml-2
														text-base
														text-neutral-500
													"
												>
													Bùng nổ
												</div>
											</div>
											<div
												class="
													text-base text-neutral-600
													font-bold
												"
											>
												{{ series3[4] }}
												%
											</div>
										</div>
									</div>
								</div>
							</div>
							<div
								class="
									bg-white
									shadow-sm
									rounded-2xl
									overflow-hidden
								"
							>
								<div class="font-semibold text-neutral-500 p-6">
									Kết quả mục tiêu đã học
								</div>
								<div
									class="
										flex flex-nowrap
										p-6
										border-t border-orange-50
										items-center
										justify-center
										md-down:flex-col
									"
								>
									<div class="relative w-fit md-down:w-full">
										<apexchart
											:options="chartOptions"
											:series="series"
											height="220"
											type="donut"
										>
										</apexchart>
										<div
											class="
												text-center
												absolute
												top-1/2
												left-1/2
												transform
											"
											style="
												transform: translate(
													-50%,
													-50%
												);
											"
										>
											<div
												class="
													text-4xl
													font-bold
													text-neutral-600
												"
											>
												{{ report?.goal_count }}
											</div>
											<div class="text-neutral-500">
												Mục tiêu
											</div>
										</div>
									</div>
									<div
										class="
											flex flex-col
											justify-center
											md-down:mt-4
										"
									>
										<div
											v-if="
												assessment_result[0]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
													blue
												"
											>
												{{
													assessment_result[0]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													whitespace-nowrap
													w-32
													shadow-input
												"
												style="background: #2aa797"
											>
												{{
													assessment_result[0]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[1]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
												"
											>
												{{
													assessment_result[1]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #65a30d"
											>
												{{
													assessment_result[1]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[2]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
												"
											>
												{{
													assessment_result[2]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #f59e0b"
											>
												{{
													assessment_result[2]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[3]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
													blue
												"
											>
												{{
													assessment_result[3]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													px-3
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #f87171"
											>
												{{
													assessment_result[3]?.result
												}}
											</span>
										</div>
										<div
											v-if="
												assessment_result[4]?.count >
													0 ||
												assessment_result[5]?.count >
													0 ||
												assessment_result[6]?.count > 0
											"
											class="
												flex flex-nowrap
												items-center
												mb-4
											"
										>
											<div
												class="
													text-sm
													font-semibold
													text-neutral-500
													w-14
													blue
												"
											>
												{{
													assessment_result[4]
														?.count +
													assessment_result[5]
														?.count +
													assessment_result[6]?.count
												}}
												M.T
											</div>
											<span
												class="
													flex
													items-center
													justify-center
													px-3
													py-0.5
													rounded-full
													text-sm text-white
													font-semibold
													w-32
													whitespace-nowrap
													shadow-input
												"
												style="background: #9ca3af"
											>
												X
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-10">
							<div
								class="
									bg-white
									shadow-sm
									rounded-2xl
									overflow-hidden
								"
							>
								<div class="font-semibold text-neutral-500 p-6">
									So sánh với tháng trước
								</div>
								<div
									class="
										border-t border-orange-50
										grid grid-cols-3
										items-start
										md-down:grid-cols-1
									"
								>
									<div
										class="
											flex flex-col
											justify-center
											items-center
											py-6
										"
									>
										<apexchart
											:options="chartOptions2_1"
											:series="[
												Math.round(
													+report?.average_result_in_percent *
														10
												) / 10,
											]"
											height="240"
											type="radialBar"
										></apexchart>
										<div
											v-show="
												+compare_with_last.average_result !==
												0
											"
											:class="
												+compare_with_last.average_result >=
												0
													? 'bg-green-50 text-green-400'
													: 'bg-sienna-50 text-sienna-400'
											"
											class="
												grow-value
												flex flex-nowrap
												rounded-lg
												py-1
												px-2
												items-center
												w-fit
											"
										>
											<svg
												:class="{
													'transform rotate-180':
														+compare_with_last.average_result >=
														0,
												}"
												fill="none"
												height="12"
												viewBox="0 0 10 12"
												width="10"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
													fill="currentColor"
													fill-rule="evenodd"
												/>
											</svg>
											<div
												class="
													ml-2
													font-bold
													text-sm text-neutral-700
												"
											>
												{{
													Math.abs(
														Math.round(
															+compare_with_last.average_result *
																10
														) / 10
													)
												}}%
											</div>
										</div>
									</div>
									<div
										class="
											flex flex-col
											justify-center
											items-center
											py-6
										"
									>
										<apexchart
											:options="chartOptions2_2"
											:series="[
												Math.round(
													((+report?.average_cooperation_scale *
														100) /
														5) *
														10
												) / 10,
											]"
											height="240"
											type="radialBar"
										></apexchart>
										<div
											v-show="
												+compare_with_last?.average_cooperation_scale !==
												0
											"
											:class="
												+compare_with_last?.average_cooperation_scale >=
												0
													? 'bg-green-50 text-green-400'
													: 'bg-sienna-50 text-sienna-400'
											"
											class="
												grow-value
												flex flex-nowrap
												rounded-lg
												py-1
												px-2
												items-center
												w-fit
											"
										>
											<svg
												:class="{
													'transform rotate-180':
														+compare_with_last?.average_cooperation_scale >=
														0,
												}"
												fill="none"
												height="12"
												viewBox="0 0 10 12"
												width="10"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
													fill="currentColor"
													fill-rule="evenodd"
												/>
											</svg>
											<div
												class="
													ml-2
													font-bold
													text-sm text-neutral-700
												"
											>
												{{
													Math.abs(
														Math.round(
															+compare_with_last?.average_cooperation_scale *
																10
														) / 10
													)
												}}%
											</div>
										</div>
									</div>
									<div
										class="
											flex flex-col
											justify-center
											items-center
											py-6
										"
									>
										<apexchart
											:options="chartOptions2_3"
											:series="[
												Math.round(
													((+report?.average_emotion_scale *
														100) /
														5) *
														10
												) / 10,
											]"
											height="240"
											type="radialBar"
										></apexchart>
										<div
											v-show="
												+compare_with_last?.average_emotion_scale !==
												0
											"
											:class="
												+compare_with_last?.average_emotion_scale >=
												0
													? 'bg-green-50 text-green-400'
													: 'bg-sienna-50 text-sienna-400'
											"
											class="
												grow-value
												flex flex-nowrap
												rounded-lg
												py-1
												px-2
												items-center
												w-fit
											"
										>
											<svg
												:class="{
													'transform rotate-180':
														+compare_with_last?.average_emotion_scale >=
														0,
												}"
												fill="none"
												height="12"
												viewBox="0 0 10 12"
												width="10"
												xmlns="http://www.w3.org/2000/svg"
											>
												<path
													clip-rule="evenodd"
													d="M4.36354 0.498901V9.45415L1.4547 6.54531L0.5 7.50001L5 12L9.5 7.50001L8.5453 6.54531L5.63646 9.45415V0.498901H4.36354Z"
													fill="currentColor"
													fill-rule="evenodd"
												/>
											</svg>
											<div
												class="
													ml-2
													font-bold
													text-sm text-neutral-700
												"
											>
												{{
													Math.abs(
														Math.round(
															+compare_with_last?.average_emotion_scale *
																10
														) / 10
													)
												}}%
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div
							class="
								bg-white
								shadow-sm
								rounded-2xl
								overflow-hidden
								mb-10
								pb-5
							"
						>
							<div class="font-semibold text-neutral-500 p-6">
								Biểu đồ mối tương quan giữa kết quả các lĩnh vực
								so sánh với tháng trước
							</div>
							<div
								class="
									p-6
									border-t border-orange-50
									md-down:px-0
									overflow-x-auto
									w-full
								"
							>
								<apexchart
									ref="mixChart2"
									:options="mixChartOptions2"
									:series="
										emotion_cooperation_result_by_day_data2
									"
									height="600"
									style="min-width: 1000px; width: 100%"
									width="100%"
								/>
							</div>
						</div>
					</div>
					<div>
						<div
							v-for="(ass, index) in skillsShow"
							:key="index"
							class="mt-10"
						>
							<div
								class="
									font-semibold
									text-lg text-neutral-600
									mb-2
								"
							>
								{{ +index + 1 }}. {{ ass?.skill?.name }}
							</div>
							<div
								class="
									shadow-sm
									sm:rounded-2xl
									overflow-hidden
									md-down:hidden
								"
							>
								<div
									class="
										__record__table
										overflow-x-auto
										scroll-bar
									"
								>
									<div
										class="
											overflow-hidden
											sm:rounded-t-2xl
											w-fit
											min-w-full
										"
									>
										<table
											class="
												min-w-full
												divide-y
												text-neutral-200
											"
										>
											<thead class="bg-neutral-100 h-16">
												<tr>
													<th
														class="
															px-4
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
															w-16
														"
														scope="col"
													>
														STT
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															w-8/12
															whitespace-nowrap
														"
														scope="col"
														style="width: 406px"
													>
														Mục Tiêu
													</th>
													<th
														class="
															px-6
															py-3
															text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
															text-left
														"
														scope="col"
														style="width: 145px"
													>
														Kết quả
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
														"
														scope="col"
														style="width: 300px"
													>
														Nhận xét
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
														"
														scope="col"
														style="width: 76px"
													>
														ALBUM
													</th>
													<th
														class="
															px-6
															py-3
															text-left text-xs
															font-semibold
															text-neutral-600
															uppercase
															tracking-wider
															whitespace-nowrap
														"
														scope="col"
														style="width: 120px"
													>
														Ghi chú
													</th>
												</tr>
											</thead>
											<tbody>
												<tr
													v-for="(
														assessment, index
													) in ass.goals"
													:key="assessment?.goal_id"
													:class="
														index % 2 === 0
															? 'bg-white'
															: 'bg-neutral-50'
													"
													class="
														cursor-pointer
														text-neutral-700
														hover:bg-orange-50
													"
													@click="
														$router.push(
															`/report/monthly-report/${report.student_id}/${assessment.goal_id}?month_start=${monthly_start}`
														)
													"
												>
													<td
														class="
															p-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div class="ml-4">
															{{ index + 1 }}
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div>
															<div
																class="
																	whitespace-normal
																"
																v-html="
																	assessment?.goal_name ||
																	assessment?.name
																"
															></div>
															<div
																class="
																	flex
																	gap-2
																	flex-wrap
																"
															>
																<div
																	v-if="
																		assessment?.raw_source
																	"
																	class="
																		mt-1
																		py-0.5
																		px-2.5
																		rounded-full
																		bg-neutral-200
																		text-neutral-700
																		h-fit
																		w-fit
																		whitespace-nowrap
																		font-semibold
																		shadow-input
																	"
																	style="
																		font-size: 10px;
																	"
																>
																	{{
																		assessment?.display_source
																	}}
																</div>
																<template
																	v-if="
																		assessment?.assistance_levels &&
																		org.enable_goal_assistance_level
																	"
																>
																	<div
																		v-for="ass in assessment?.assistance_levels"
																		:key="
																			ass
																		"
																	>
																		<div
																			class="
																				mt-1
																				py-0.5
																				px-2.5
																				rounded-full
																				bg-pink-100
																				whitespace-nowrap
																				text-neutral-700
																				h-fit
																				w-fit
																				font-semibold
																				shadow-input
																			"
																			style="
																				font-size: 10px;
																			"
																		>
																			{{
																				ass
																			}}
																		</div>
																	</div>
																</template>
																<div
																	class="
																		mt-1
																		py-0.5
																		px-2.5
																		rounded-full
																		bg-yellow-tag
																		text-neutral-700
																		h-fit
																		w-fit
																		font-semibold
																		shadow-input
																		whitespace-nowrap
																	"
																	style="
																		font-size: 10px;
																	"
																	v-if="
																		assessment?.age
																	"
																>
																	{{
																		assessment?.age
																	}}
																</div>
															</div>
															<div
																class="
																	flex
																	items-center
																	gap-2
																	mt-2
																"
															>
																<div
																	v-if="
																		assessment?.has_media
																	"
																>
																	<img
																		alt=""
																		src="@/assets/images/icons/has_media.png"
																	/>
																</div>
																<div
																	v-if="
																		assessment.number_of_assessment >
																		0
																	"
																	class="
																		text-neutral-400
																		text-xs
																		font-semibold
																	"
																>
																	ĐÃ HỌC
																	{{
																		assessment.number_of_assessment
																	}}
																	NGÀY
																</div>
																<div
																	v-if="
																		assessment?.completed_at
																	"
																>
																	<img
																		alt=""
																		src="@/assets/images/icons/has_taught.png"
																	/>
																</div>
															</div>
															<div
																v-if="
																	assessment
																		?.parent
																		?.sub_goal_count >
																	0
																"
																class="
																	p-3
																	py-2
																	rounded-xl
																	border
																	mt-2
																	flex
																	gap-3
																"
																style="
																	border: 1px
																		solid
																		#bacde4;
																	background: #eef3f8;
																"
															>
																<div
																	class="w-4"
																>
																	<svg
																		fill="none"
																		height="16"
																		viewBox="0 0 16 16"
																		width="16"
																		xmlns="http://www.w3.org/2000/svg"
																	>
																		<path
																			d="M2.66663 2.6665V8.6665C2.66663 9.37375 2.94758 10.052 3.44768 10.5521C3.94777 11.0522 4.62605 11.3332 5.33329 11.3332H11.3906L9.72396 12.9998L10.6666 13.9425L13.9426 10.6665L10.6666 7.3905L9.72396 8.33317L11.3906 9.99984H5.33329C4.97967 9.99984 4.64053 9.85936 4.39048 9.60931C4.14044 9.35926 3.99996 9.02013 3.99996 8.6665V2.6665H2.66663Z"
																			fill="#94A3B8"
																		/>
																	</svg>
																</div>
																<div>
																	<div
																		class="
																			whitespace-normal
																		"
																		v-html="
																			assessment
																				?.parent
																				?.name ??
																			assessment
																				?.parent
																				?.goal_name
																		"
																	></div>
																	<div
																		class="
																			text-sm
																			font-semibold
																		"
																		style="
																			color: #94a3b8;
																		"
																	>
																		{{
																			assessment
																				?.parent
																				?.sub_goal_count
																		}}
																		mục tiêu
																	</div>
																</div>
															</div>
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div
															v-if="
																assessment
																	?.assessment_report
																	?.result
															"
															:style="{
																background:
																	$filters.tagResult(
																		assessment
																			?.assessment_report
																			?.result
																	)
																		?.background,
																color: $filters.tagResult(
																	assessment
																		?.assessment_report
																		?.result
																)?.color,
															}"
															class="
																py-0.5
																px-2.5
																rounded-full
																text-neutral-700
																h-fit
																w-fit
																font-semibold
																text-sm
																shadow-input
															"
														>
															{{
																assessment
																	?.assessment_report
																	?.result
															}}
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div
															v-if="
																assessment
																	?.assessment_report
																	?.note
															"
															class="
																whitespace-normal
															"
														>
															{{
																assessment
																	?.assessment_report
																	?.note
															}}
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div>
															<svg
																v-if="
																	assessment
																		?.assessment_report
																		?.has_goal_media
																"
																fill="none"
																height="20"
																viewBox="0 0 20 20"
																width="20"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	clip-rule="evenodd"
																	d="M15.002 5H2.50195C1.8116 5 1.25195 5.55964 1.25195 6.25V16.25L4.56001 13.3081C4.77068 13.0974 5.10075 13.0647 5.34864 13.23L8.67232 15.4458L13.31 10.8081C13.5002 10.6179 13.7908 10.5707 14.0315 10.691L16.252 13.125V6.25C16.252 5.55964 15.6923 5 15.002 5ZM2.50195 3.75C1.12124 3.75 0.00195312 4.86929 0.00195312 6.25V16.25C0.00195312 17.6307 1.12124 18.75 2.50195 18.75H15.002C16.3827 18.75 17.502 17.6307 17.502 16.25V6.25C17.502 4.86929 16.3827 3.75 15.002 3.75H2.50195ZM7.50195 9.375C7.50195 10.4105 6.66249 11.25 5.62695 11.25C4.59142 11.25 3.75195 10.4105 3.75195 9.375C3.75195 8.33947 4.59142 7.5 5.62695 7.5C6.66249 7.5 7.50195 8.33947 7.50195 9.375Z"
																	fill="#E5A42B"
																	fill-rule="evenodd"
																/>
																<path
																	clip-rule="evenodd"
																	d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
																	fill="#E5A42B"
																	fill-rule="evenodd"
																/>
															</svg>
														</div>
													</td>
													<td
														class="
															px-6
															py-4
															whitespace-nowrap
															text-neutral-700
														"
													>
														<div
															class="
																whitespace-normal
																w-56
															"
														>
															<div
																class="
																	w-56
																	flex
																	items-center
																	gap-1
																"
																v-if="
																	assessment
																		?.assessment_report
																		.next_plan ==
																	'Mục tiêu đã hoàn thành'
																"
															>
																<svg
																	width="16"
																	height="16"
																	viewBox="0 0 16 16"
																	fill="none"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		fill-rule="evenodd"
																		clip-rule="evenodd"
																		d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM12.0303 4.96967C11.7374 4.67678 11.2625 4.67678 10.9697 4.96967C10.9626 4.97674 10.9559 4.98424 10.9498 4.9921L7.47739 9.41674L5.38387 7.32322C5.09097 7.03033 4.6161 7.03033 4.32321 7.32322C4.03031 7.61612 4.03031 8.09099 4.32321 8.38388L6.96965 11.0303C7.26255 11.3232 7.73742 11.3232 8.03031 11.0303C8.03684 11.0238 8.04299 11.0169 8.04875 11.0097L12.041 6.01947C12.3232 5.72582 12.3196 5.25897 12.0303 4.96967Z"
																		fill="#2AA797"
																	/>
																</svg>

																<div>
																	Mục tiêu đã
																	hoàn thành
																</div>
															</div>
															<div
																class="
																	whitespace-normal
																	w-56
																"
																v-else
															>
																{{
																	reason(
																		assessment?.assessment_report
																	)
																}}
															</div>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div>
								<div
									v-for="(assessment, index) in ass?.goals"
									:key="assessment.goal_id"
									class="
										shadow-sm
										rounded-lg
										overflow-hidden
										md:hidden
										mb-4
										bg-white
									"
									@click="
										$router.push(
											`/report/monthly-report/${report.student_id}/${assessment.goal_id}?month_start=${monthly_start}`
										)
									"
								>
									<div
										class="
											font-semibold
											text-neutral-600
											p-4
										"
									>
										<div>
											{{ index + 1 }}.
											{{
												assessment?.goal_name ||
												assessment?.name
											}}
										</div>
									</div>
									<div class="p-4 border-t border-orange-100">
										<div
											v-if="
												assessment?.assessment_report
													?.note
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
											"
										>
											Nhận xét
										</div>
										<div class="mt-2">
											{{
												assessment?.assessment_report
													?.note
											}}
										</div>
										<div
											v-if="
												reason(
													assessment?.assessment_report
												)
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
												mt-4
											"
										>
											Album
										</div>
										<div class="mt-2">
											<div>
												<svg
													v-if="
														assessment
															?.assessment_report
															?.has_goal_media
													"
													fill="none"
													height="20"
													viewBox="0 0 20 20"
													width="20"
													xmlns="http://www.w3.org/2000/svg"
												>
													<path
														clip-rule="evenodd"
														d="M15.002 5H2.50195C1.8116 5 1.25195 5.55964 1.25195 6.25V16.25L4.56001 13.3081C4.77068 13.0974 5.10075 13.0647 5.34864 13.23L8.67232 15.4458L13.31 10.8081C13.5002 10.6179 13.7908 10.5707 14.0315 10.691L16.252 13.125V6.25C16.252 5.55964 15.6923 5 15.002 5ZM2.50195 3.75C1.12124 3.75 0.00195312 4.86929 0.00195312 6.25V16.25C0.00195312 17.6307 1.12124 18.75 2.50195 18.75H15.002C16.3827 18.75 17.502 17.6307 17.502 16.25V6.25C17.502 4.86929 16.3827 3.75 15.002 3.75H2.50195ZM7.50195 9.375C7.50195 10.4105 6.66249 11.25 5.62695 11.25C4.59142 11.25 3.75195 10.4105 3.75195 9.375C3.75195 8.33947 4.59142 7.5 5.62695 7.5C6.66249 7.5 7.50195 8.33947 7.50195 9.375Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
													<path
														clip-rule="evenodd"
														d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
														fill="#E5A42B"
														fill-rule="evenodd"
													/>
												</svg>
												<div v-else>-</div>
											</div>
										</div>
										<div
											v-if="
												reason(
													assessment?.assessment_report
												)
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
												mt-4
											"
										>
											Ghi chú
										</div>
										<div
											v-if="
												reason(
													assessment?.assessment_report
												)
											"
											class="mt-2"
										>
											{{
												reason(
													assessment?.assessment_report
												)
											}}
										</div>
										<div
											v-if="
												assessment?.assessment_report
													?.result
											"
											class="
												uppercase
												font-semibold
												text-neutral-400
												mt-4
											"
										>
											Kết quả
										</div>
										<div
											v-if="
												assessment?.assessment_report
													?.result
											"
											:style="{
												background: $filters.tagResult(
													assessment
														?.assessment_report
														?.result
												)?.background,
												color: $filters.tagResult(
													assessment
														?.assessment_report
														?.result
												)?.color,
											}"
											class="
												mt-2
												mb-4
												py-0.5
												px-2.5
												rounded-full
												text-neutral-700
												h-fit
												w-fit
												font-semibold
												text-xs
												shadow-input
											"
										>
											{{
												assessment?.assessment_report
													?.result
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else class="fixed top-1/2 left-1/2">
			<Loading />
		</div>
	</div>
</template>

<script setup>
import { $api } from '@/services';
import { computed, onMounted, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { _GET_DATE_2 } from '@/helper/formatDate';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Loading from '@/components/common/Loading.vue';
import { _MONTH_DIFF } from '@/helper/monthDiff';
import dayjs from 'dayjs';
import { useRoute } from 'vue-router';

const route = useRoute();
const store = useStore();
const id = computed(() => route.params?.student_id);
const monthly_start = ref(route.query.month_start);
const goalSelectedId = ref(route.query.goal);
const goalSelected = ref(null);
const goalSelected__next = ref(null);
const goalIndex = ref(0);
const skillIndex = ref(0);
const report = ref(null);
const skills = ref(null);
const skillsShow = ref(null);
const all_goals_reported = ref(false);
const isLoading = ref(true);
const is_old_data = computed(() => route.query.is_old_data);
let org = ref({
	value: {
		note: '',
	},
});
let assessment_result = ref([]);
let assessment_report_next_plan = ref(null);
let series = ref([]);
let series3 = ref([]);
let radarData = ref([]);
let categories = ref([]);
const radarChartOptions = ref({
	chart: {
		id: 'radarChart',
		type: 'radar',
	},
	title: {
		show: false,
	},
	stroke: {
		width: 0,
	},
	fill: {
		opacity: 0.2,
		colors: ['#65A30D'],
	},
	markers: {
		size: 5,
		hover: {
			size: 10,
		},
		colors: ['#65A30D'],
	},
	dataLabels: {
		enabled: true,
		formatter: function (val) {
			return val + '%';
		},
		style: {
			fontFamily: 'Gilrory',
			fontSize: '20px',
			fontWeight: 'bold',
			colors: ['#344256'],
		},
		background: {
			enabled: false,
		},
	},
	yaxis: {
		show: false,
		logBase: 100,
		tickAmount: 10,
		min: 0,
		max: 100,
		labels: {
			show: false,
		},
	},
	xaxis: {
		categories: [],
		labels: {
			show: true,
			style: {
				fontFamily: 'Gilrory',
				fontSize: '14px',
				fontWeight: 600,
				colors: Array(1000).fill('#344256'),
			},
			formatter: function (val, index) {
				return index?.dataPointIndex + 1;
			},
		},
	},
	tooltip: {
		x: {
			show: true,
			formatter: function (val, object) {
				return `${object?.dataPointIndex + 1}: ${val}`;
			},
			title: {
				formatter: (seriesName) => seriesName,
			},
		},
		y: {
			show: true,
			formatter: function (val) {
				return val + '%';
			},
			title: {
				title: {
					formatter: (seriesName) => seriesName + ':',
				},
			},
		},
	},
});
let emotion_scale = ref([]);
let assessments_by_skill = ref([]);
let series3Total = ref(0);
const compare_with_last = ref({
	average_cooperation_scale: '0.0',
	average_emotion_scale: '0.0',
	average_result: '0.0',
});
const attendance = ref({
	attendance_compare_with_last_percent: '0.0',
	attendance_percent: '100.0',
	completed: 2,
	total: 2,
});
let emotion_cooperation_result_by_day = ref([]);
let emotion_cooperation_result_by_day_emotion = ref([]);
let emotion_cooperation_result_by_day_rating = ref([]);
let emotion_cooperation_result_by_day_result = ref([]);
let emotion_cooperation_result_by_day_labels = ref([]);
let emotion_cooperation_result_by_day_data = ref([
	{
		name: 'Cảm xúc',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Sự tham gia',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Kết quả buổi học',
		type: 'line',
		data: [0, 0, 0, 0, 0],
	},
]);
let emotion_cooperation_result_by_day_data2 = ref([
	{
		name: 'Tháng 12/2023',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
	{
		name: 'Tháng 12/2023',
		type: 'column',
		data: [0, 0, 0, 0, 0],
	},
]);

const mixChart = ref(null);
const mixChart2 = ref(null);
const mixChartOptions = ref({
	chart: {
		type: 'line',
		stacked: false,
	},
	dataLabels: {
		enabled: true,
		enabledOnSeries: [0, 1],
		offsetY: -10,
		background: {
			enabled: true,
			foreColor: '#334155',
		},
		formatter: function (val) {
			return val + '%';
		},
	},
	stroke: {
		width: [0.5, 0.5, 4],
	},
	yaxis: [
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
	],
	tooltip: {
		fixed: {
			enabled: true,
			position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
			offsetY: 30,
			offsetX: 60,
		},
	},
	legend: {
		horizontalAlign: 'left',
		offsetX: 40,
	},
	plotOptions: {
		bar: {
			horizontal: false,
			columnWidth: '20%',
			borderRadius: 4,
		},
	},
	labels: [],
	colors: ['#FFD270', '#DA8F8F', '#6ED0B9'],
	markers: {
		size: 8,
		strokeColors: '#fff',
		strokeWidth: 2,
	},
});
const mixChartOptions2 = ref({
	chart: {
		type: 'line',
		stacked: false,
	},
	dataLabels: {
		enabled: true,
		enabledOnSeries: [0, 1],
		offsetY: -10,
		background: {
			enabled: true,
			foreColor: '#334155',
		},
		formatter: function (val) {
			return val + '%';
		},
	},
	stroke: {
		width: [0.5, 0.5],
	},
	yaxis: [
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
		{
			opposite: false,
			axisTicks: {
				show: false,
			},
			axisBorder: {
				show: false,
			},
			labels: {
				show: false,
				formatter: function (value) {
					if (!value || value == 'null') {
						return 'Không thực hiện';
					}
					return value + '%';
				},
			},
			title: {
				show: false,
			},
			max: 100,
		},
	],
	xaxis: {
		categories: [],
	},
	tooltip: {
		fixed: {
			enabled: true,
			position: 'topLeft',
			offsetY: 30,
			offsetX: 60,
		},
	},
	legend: {
		horizontalAlign: 'left',
		offsetX: 40,
	},
	plotOptions: {
		bar: {
			horizontal: false,
			columnWidth: '10%',
			borderRadius: 4,
			distributed: false,
		},
	},
	labels: [],
	colors: ['#F59E0B', '#2AA797'],
	markers: {
		size: 8,
		strokeColors: '#fff',
		strokeWidth: 2,
	},
});
const chartOptions = ref({
	dataLabels: {
		enabled: false,
	},
	colors: ['#7AD2C6', '#93BF56', '#F8BB54', '#F47C7C', '#E5E7EB'],
	labels: [
		'Đạt 80 - 100%',
		'Đạt 55 - 75%',
		'Đạt 30 - 50%',
		'Đạt 5 - 25%',
		'X',
	],
	legend: {
		show: false,
	},
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				return value + ' mục tiêu';
			},
		},
	},
	stroke: {
		lineCap: 'round',
	},
});
const chartOptions2_1 = ref({
	chart: {
		type: 'radialBar',
	},
	plotOptions: {
		radialBar: {
			hollow: {
				size: '54%',
			},
			dataLabels: {
				name: {
					offsetY: -10,
					show: true,
					color: '#65758B',
					fontWeight: 'normal',
					fontSize: '13px',
				},
				value: {
					color: '#48566A',
					fontSize: '24px',
					show: true,
					fontWeight: 'bold',
				},
			},
		},
	},
	fill: {
		colors: '#6ED0B9',
	},
	stroke: {
		lineCap: 'round',
	},
	labels: ['Kết quả'],
});
const chartOptions2_2 = ref({
	chart: {
		type: 'radialBar',
	},
	plotOptions: {
		radialBar: {
			hollow: {
				size: '54%',
			},
			dataLabels: {
				name: {
					offsetY: -10,
					show: true,
					color: '#65758B',
					fontWeight: 'normal',
					fontSize: '13px',
				},
				value: {
					color: '#48566A',
					fontSize: '24px',
					show: true,
					fontWeight: 'bold',
				},
			},
		},
	},
	fill: {
		colors: '#FFD270',
	},
	stroke: {
		lineCap: 'round',
	},
	labels: ['Sự tham gia'],
});
const chartOptions2_3 = ref({
	chart: {
		type: 'radialBar',
	},
	plotOptions: {
		radialBar: {
			hollow: {
				size: '54%',
			},
			dataLabels: {
				name: {
					offsetY: -10,
					show: true,
					color: '#65758B',
					fontWeight: 'normal',
					fontSize: '13px',
					fontFamily: 'SVN-Gilroy',
				},
				value: {
					color: '#48566A',
					fontSize: '24px',
					show: true,
					fontWeight: 'bold',
				},
			},
		},
	},
	fill: {
		colors: '#DA8F8F',
	},
	stroke: {
		lineCap: 'round',
	},
	labels: ['Cảm xúc'],
});
const chartOptions3 = ref({
	colors: ['#9EDF93', '#D0DB54', '#FFE68C', '#FF9D6D', '#FF6967'],
	chart: {
		width: 380,
		type: 'polarArea',
	},
	labels: ['Vui vẻ', 'Bình thường', 'Khó chịu', 'Tức giận', 'Bùng nổ'],
	fill: {
		opacity: 1,
		colors: ['#9EDF93', '#D0DB54', '#FFE68C', '#FF9D6D', '#FF6967'],
	},
	stroke: {
		lineCap: 'round',
	},
	yaxis: {
		show: false,
	},
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				if (!value || value == 'null') {
					return 'Không thực hiện';
				}
				return value + '%';
			},
		},
	},
	legend: {
		show: false,
	},
	dataLabels: {
		enabled: false,
	},
	plotOptions: {
		polarArea: {
			rings: {
				strokeWidth: 0,
			},
			spokes: {
				strokeWidth: 0,
			},
		},
	},
});

const stats = ref({
	total_goal_count: 0,
	total_skill_count: 0,
});
onMounted(() => {
	fetchReport();
});

async function fetchReport() {
	try {
		emotion_cooperation_result_by_day.value = [];
		emotion_cooperation_result_by_day_emotion.value = [];
		emotion_cooperation_result_by_day_rating.value = [];
		emotion_cooperation_result_by_day_result.value = [];
		emotion_cooperation_result_by_day_labels.value = [];
		emotion_cooperation_result_by_day_data.value = [
			{
				name: 'Kết quả buổi học',
				type: 'line',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Sự tham gia',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Cảm xúc',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
		];
		emotion_cooperation_result_by_day_data2.value = [
			{
				name: 'Tháng 12/2023',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
			{
				name: 'Tháng 01/2024',
				type: 'column',
				data: [0, 0, 0, 0, 0],
			},
		];
		const listGroup = ref([]);
		const res = await fetch(
			process.env.VUE_APP_BASE_URL +
				`v1/staff/students/${id.value}/monthly_reports?month_start=${monthly_start.value}`,
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					'x-access-token': route?.query?.token,
					'x-subdomain': route?.query?.subdomain,
				},
			}
		);

		const data = await res.json();
		const response = await fetch(
			process.env.VUE_APP_BASE_URL +
				`v1/staff/students/${id.value}/groups_with_goals_for_monthly_report?monthly_report_id=${data?.data?.id}`,
			{
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
					'x-access-token': route?.query?.token,
					'x-subdomain': route?.query?.subdomain,
				},
			}
		);
		listGroup.value = await response.json();
		if (
			listGroup.value?.length &&
			listGroup.value[0].id !== 'no_have_group'
		) {
			skills.value = listGroup.value;
		} else {
			skills.value = data?.skills ?? [];
		}
		skillsShow.value = data?.skills ?? [];
		if (data) {
			report.value = data.data;
			all_goals_reported.value = data.all_goals_reported;
			if (data?.org) {
				org.value = data?.org;
			}
			if (!goalSelectedId.value) {
				goalSelected.value = skills.value[0]?.goals[0];
				goalIndex.value = 0;
				skillIndex.value = 0;
				if (
					skills.value[skillIndex.value]?.goals?.length >
					goalIndex.value + 1
				) {
					goalSelected__next.value =
						skills.value[skillIndex.value]?.goals[
							goalIndex.value + 1
						];
				} else {
					goalSelected__next.value =
						skills.value[skillIndex.value + 1]?.goals[0];
				}
			}
			if (data?.stats) {
				stats.value = data.stats;

				if (data?.stats.compare_with_last) {
					compare_with_last.value = data?.stats.compare_with_last;
				}

				if (data?.stats.attendance) {
					attendance.value = data?.stats.attendance;
				}

				if (data?.stats.assessment_report_next_plan) {
					assessment_report_next_plan.value =
						data?.stats.assessment_report_next_plan;
				}
			}
			if (data?.stats?.assessment_results) {
				assessment_result.value = data?.stats?.result;
				emotion_cooperation_result_by_day.value =
					data?.stats?.emotion_cooperation_result_by_day;
				assessments_by_skill.value = data?.stats?.assessment_results;
				emotion_scale.value = data?.stats?.emotion_scale;
				emotion_scale.value.forEach((item) => {
					return (series3Total.value += item.count);
				});
				series3.value = emotion_scale.value.map((item) => {
					const r = (item.count * 100) / series3Total.value;
					return Math.round(r * 10) / 10 || 0;
				});
				let a = [];
				let count = 0;
				assessment_result.value.forEach((item) => {
					if (
						item.result === 'Từ chối' ||
						item.result === 'Không có cơ hội' ||
						item.result === 'Không hợp tác'
					) {
						count += item.count;
					} else {
						a.push(item);
					}
				});
				a.push({
					result: 'X',
					count: count,
				});
				series.value = a.map((item) => {
					return item.count;
				});
				emotion_cooperation_result_by_day.value.forEach((item) => {
					emotion_cooperation_result_by_day_emotion.value.push(
						+(+item.emotion_scale / 5) * 100 || null
					);
					emotion_cooperation_result_by_day_rating.value.push(
						+(+item.cooperation_scale / 5) * 100 || null
					);
					emotion_cooperation_result_by_day_result.value.push(
						+item.complete_percent || null
					);
					//@ts-ignore
					emotion_cooperation_result_by_day_labels.value.push(
						_GET_DATE_2(item.date, true)
					);
				});
				emotion_cooperation_result_by_day_data.value[1] = {
					name: 'Cảm xúc',
					type: 'column',
					data: emotion_cooperation_result_by_day_emotion.value,
				};
				emotion_cooperation_result_by_day_data.value[0] = {
					name: 'Sự tham gia',
					type: 'column',
					data: emotion_cooperation_result_by_day_rating.value,
				};
				emotion_cooperation_result_by_day_data.value[2] = {
					name: 'Kết quả buổi học',
					type: 'line',
					data: emotion_cooperation_result_by_day_result.value,
				};
			}
			if (data.skills) {
				radarData.value = [
					{
						name: 'Kết quả',
						data: data.skills.map((skill) => {
							return skill?.skill?.skill_percent;
						}),
					},
				];
				radarChartOptions.value.xaxis.categories = data.skills.map(
					(skill) => {
						return skill?.skill?.name;
					}
				);
				categories.value = data.skills.map((skill) => {
					return skill?.skill?.name;
				});
				emotion_cooperation_result_by_day_data2.value[1] = {
					name: `Tháng ${dayjs(data?.data.apply_date).format(
						'MM/YYYY'
					)}`,
					type: 'column',
					data: data?.skills?.map(
						(s) => +s.skill?.skill_percent || 0
					),
				};
			}
			if (data?.previous_month_skills) {
				const previous_month_skills = [];
				data?.skills.forEach((item) => {
					const o = data?.previous_month_skills?.find(
						(s) => s.skill.id === item.skill.id
					);
					if (o) {
						previous_month_skills.push(
							+o.skill?.skill_percent || 0
						);
					} else {
						previous_month_skills.push(0);
					}
				});
				emotion_cooperation_result_by_day_data2.value[0] = {
					name: `Tháng ${dayjs(data?.previous_month_start).format(
						'MM/YYYY'
					)}`,
					type: 'column',
					data: previous_month_skills,
				};
			}
		}
	} catch (e) {
		console.log(e);
	} finally {
		isLoading.value = false;
	}
}

function reason(as) {
	const stopped_reason = as?.stopped_reason
		? as?.stopped_reason.toLowerCase()
		: '';
	const stopped_reason_other = as?.stopped_reason_other || '';
	const other =
		stopped_reason !== 'Khác' && stopped_reason !== 'other'
			? stopped_reason
			: stopped_reason_other;
	return as?.next_plan !== 'Tạm dừng mục tiêu'
		? as?.next_plan
		: `${as?.next_plan} ${other ? ' vì ' + other : ''}`;
}

onMounted(() => {
	window.scrollTo(0, 0);
});

const dateData = computed(() => {
	const join_date = route.query.join_date;
	const left_date = route.query.left_date;
	if (!join_date) {
		return '';
	}
	return `${_GET_DATE_2(join_date)} - ${
		left_date ? _GET_DATE_2(left_date) : 'Hiện tại'
	} | Đã học ${_MONTH_DIFF(join_date, left_date)} tháng`;
});

watch(
	mixChart,
	() => {
		const optimalColumnWidthPercent =
			5 +
			15 /
				(1 +
					30 *
						Math.exp(
							-emotion_cooperation_result_by_day_labels.value
								?.length / 3
						));

		setTimeout(() => {
			mixChart.value?.updateOptions({
				labels: emotion_cooperation_result_by_day_labels.value,
				plotOptions: {
					bar: {
						columnWidth: optimalColumnWidthPercent + '%',
					},
				},
			});
		}, 1000);
	},
	{ immediate: true, deep: true }
);

watch(
	mixChart2,
	() => {
		const optimalColumnWidthPercent =
			12 + 16 / (1 + 30 * Math.exp(-categories.value?.length / 3));

		setTimeout(() => {
			mixChart2.value?.updateOptions({
				labels: categories.value,
				plotOptions: {
					bar: {
						columnWidth: optimalColumnWidthPercent + '%',
					},
				},
			});
		}, 1000);
	},
	{ immediate: true, deep: true }
);
</script>
<style lang="scss" scoped>
@import '../../../../assets/styles/responsive';

.is-MT-show {
	width: 100vw;
	transform: translateX(0);
	transition: all 0.4s ease;

	@include media-breakpoint-up(xl) {
		width: 400px;
	}
}

.is-MT-hide {
	transform: translateX(450px);
	transition: all 0.4s ease;
}

.transition {
	transition: all 0.4s ease;
}

.content-report-is-show {
	@include media-breakpoint-up(lg) {
		padding-right: 448px;
	}
}

.content-report-is-hide {
	@include media-breakpoint-up(lg) {
		padding-right: 40px;
	}
}
</style>
